import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { API_BASE_URL } from "../constants/apiConfig";

// The Dummy Data
const MOCK_RESPONSE = {
  "data": [
    {
      "subject": "Tamil",
      "Repeated": 0,
      "Important": 0,
      "PreviousYear": 0,
      "Current_Affairs": 0,
      "None": 343
    },
    {
      "subject": "English",
      "Repeated": 0,
      "Important": 0,
      "PreviousYear": 0,
      "Current_Affairs": 0,
      "None": 1
    },
    {
      "subject": "History",
      "Repeated": 0,
      "Important": 0,
      "PreviousYear": 0,
      "Current_Affairs": 0,
      "None": 15
    },
    {
      "subject": "Polity",
      "Repeated": 0,
      "Important": 0,
      "PreviousYear": 0,
      "Current_Affairs": 0,
      "None": 4
    },
    {
      "subject": "Science",
      "Repeated": 0,
      "Important": 0,
      "PreviousYear": 0,
      "Current_Affairs": 0,
      "None": 7
    },
    {
      "subject": "CurrentAffairs",
      "Repeated": 0,
      "Important": 0,
      "PreviousYear": 0,
      "Current_Affairs": 0,
      "None": 13
    },
    {
      "subject": "Aptitude",
      "Repeated": 0,
      "Important": 0,
      "PreviousYear": 0,
      "Current_Affairs": 0,
      "None": 9
    }
  ],
  "totalCount": 393
}

const AllQuestionVisuals = () => {
  const [questionStats, setQuestionStats] = useState(MOCK_RESPONSE);

  useEffect(() => {
    fetch(`${API_BASE_URL}/admin/allqus_stats`, {
      credentials: "include",
    })
      .then((response) => response.json())
      
      .then((data: any) => {
        console.log("Fetched question stats:", data);
        setQuestionStats(data);
      })
      .catch((error) => {
        console.error("Error fetching question stats:", error);
      });
  }, []);
  return (
    <div className="p-8 bg-base-200 min-h-screen space-y-6">
      {/* DaisyUI Total Stat Card */}
      <div className="stats shadow bg-base-100 w-full max-w-sm">
        <div className="stat">
          <div className="stat-title text-slate-500">Total Questions Bank</div>
          <div className="stat-value text-primary">{questionStats.totalCount}</div>
          <div className="stat-desc">Updated just now</div>
        </div>
      </div>

      {/* Recharts Stacked Bar Chart Card */}
      <div className="card bg-base-100 shadow-xl p-6 w-full">
        <div className="card-body p-0">
          <h2 className="card-title text-xl mb-6">Questions by Subject & Category</h2>
          <div className="h-80 w-full">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={questionStats.data} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="subject" />
                <YAxis />
                <Tooltip 
                   contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
                />
                <Legend iconType="circle" />
                {/* DaisyUI-themed colors: Primary, Secondary, Accent */}
                <Bar dataKey="Repeated" stackId="stack" fill="#570df8" radius={[0, 0, 0, 0]} />
                <Bar dataKey="Important" stackId="stack" fill="#f000b8" />
                <Bar dataKey="PreviousYear" stackId="stack" fill="#37cdbe" radius={[4, 4, 0, 0]} />
                <Bar dataKey="Current_Affairs" stackId="stack" fill="#a3e635" />
                <Bar dataKey="None" stackId="stack" fill="#cbd5e1" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllQuestionVisuals;
